import { getToken } from "../../services/HttpService";


export const putCloseSession = async (token) => {

    /* const endPoint = `https://${types.apiID}.execute-api.us-east-1.amazonaws.com/auth`;  */
    const endPoint = `${process.env.REACT_APP_API}/auth`; 
    const response = await getToken();

    const resp = await fetch(endPoint,{
        headers: {
            token,
            Authorization: `Bearer ${response.token}`,
            "Content-Type": "application/json"
        },
        method: 'PUT',
        redirect: "follow"
    })

    return await resp.json();
}
